import {constants} from "../../constants";

export const toggleChangePasswordModal = () => {
    return { type: constants.CHANGE_PASSWORD_MODEL_ACTION };
};
